import { FormBase } from '@/libs/form/base'

export class FormSection extends FormBase {
    __type = 'section'

    constructor (key, configuration = {}) {
        super(key, configuration)
    }
}
